import { EngineeringJudgement } from '../../../../../EJLog/EJLogContext/types'

type GetReportNameProps = Partial<
  Pick<
    EngineeringJudgement['ejToReports'][number],
    | 'concretePlacement'
    | 'concreteTest'
    | 'lot'
    | 'dailyInspectionControlPoint'
    | 'dailyInspectionInspection'
  > &
    Pick<
      NonNullable<EngineeringJudgement['identifiedFieldIssue']>,
      'asphaltLot' | 'dailyInspectionPunchList'
    >
>

export function getReportName({
  concretePlacement,
  concreteTest,
  lot,
  dailyInspectionControlPoint,
  dailyInspectionInspection,
  asphaltLot,
  dailyInspectionPunchList,
}: GetReportNameProps) {
  if (concretePlacement)
    return concretePlacement.placementId ?? concretePlacement.globalId
  if (concreteTest) return concreteTest.fieldNumber ?? concreteTest.globalId
  if (lot) return lot.lotId ?? lot.globalId
  if (dailyInspectionControlPoint)
    return (
      dailyInspectionControlPoint.controlPointId ??
      dailyInspectionControlPoint.globalId
    )
  if (dailyInspectionInspection)
    return (
      dailyInspectionInspection.inspectionId ??
      dailyInspectionInspection.globalId
    )
  if (asphaltLot) return asphaltLot.asphaltLotId ?? asphaltLot.globalId
  if (dailyInspectionPunchList)
    return (
      dailyInspectionPunchList.punchListId ?? dailyInspectionPunchList.globalId
    )
  return undefined
}
